import React from "react";

const Privacy = () => {
  return (
    <div className="flex flex-col items-start  sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide mx-auto">
        <span className="text-[#01A7D1]">Privacy</span> Policy
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        This Privacy Policy expresses our firm commitment to aid our users
        better understand what information we collect about them and what may
        happen to that information.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        This Privacy Policy was last updated on 18th June, 2022. This Privacy
        Policy is effective from 8th February, 2018.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Yostel (under the brand name "Yostel") values your privacy. In this
        Privacy Policy ("Policy"), we describe the information that we collect
        about you when you visit our website www.Yostelliving.com and Mobile
        Applications Yostel- Student Residence Community“ (herein after Website
        & Mobile Applications collectively be referred to as “Platform”), and
        use the services available on the Website ("Services"), and how we use
        and disclose that information.
        <br />
        This Policy is accessible at{" "}
        <a href="#" className="text-blue-500 cursor-pointer">
          https://www.yostelhostel.com/privacy-policy
        </a>
        and is subject to the Yostel Terms of Use, which can be accessed at
        <a href="#" className="text-blue-500 cursor-pointer">
          https://www.yostelhostel.com/terms-and-conditions.
        </a>
        Your use of the Website and/or Services and any personal information you
        provide on the Platform remains subject to the terms of the Policy and
        Yostel’s Terms of Use.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Grievance Officer
        <br /> In accordance with Information Technology Act 2000 and
        Information Technology (Reasonable security practices and procedures and
        sensitive personal data or information) Rules, 2011, the name and
        contact details of the Grievance Officer are provided below:
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        Mr. Abinash Mohanty <br />
        Yostel
        <br /> A/310, Saheed Nagar, Bhubaneswar <br />
        Phone: 8328991641
        <br /> Email: hello.yostel@gmail.com
        <br /> Time: Monday- Friday (9:00 - 18:00)
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Note:
        <br /> In accordance with Information Technology Act 2000 and
        Information Technology (Reasonable security practices and procedures and
        sensitive personal data or information) Rules, 2011, the name and
        contact details of the Grievance Officer are provided below:
      </p>
    </div>
  );
};

export default Privacy;
